import lscache from "lscache";

import {PHONE_VERIFICATION_CODE_SENT_LS_KEY} from "../../constants/phone_verification_constants";
import {getPhoneVerificationCodeRemainingTime} from "./get_phone_verification_code_remaining_time";

// First SMS in a flow: send once on mount. Later mounts only resend on demand (sending sets the LS flag).
export const shouldAutoSendPhoneVerificationCode = (timerStartTime: number | null) =>
    !lscache.get(PHONE_VERIFICATION_CODE_SENT_LS_KEY) && getPhoneVerificationCodeRemainingTime(timerStartTime) === 0;
import lscache from "lscache";

import {PHONE_VERIFICATION_CODE_SENT_LS_KEY} from "../../constants/phone_verification_constants";
import {getPhoneVerificationCodeRemainingTime} from "./get_phone_verification_code_remaining_time";

// First SMS in a flow: send once on mount. Later mounts only resend on demand (sending sets the LS flag).
export const shouldAutoSendPhoneVerificationCode = (timerStartTime: number | null) =>
    !lscache.get(PHONE_VERIFICATION_CODE_SENT_LS_KEY) && getPhoneVerificationCodeRemainingTime(timerStartTime) === 0;
